<div class="wrapper-insights-page">
  <span class="title-settings-page">{{viewAllList ? ('INSIGHTS.content_you_created' | translate) : ('INSIGHTS.insights' | translate)}}</span>
  <div class="header-insights">
    <div class="wrapper-datepicker">
      <div (click)="isDatepickerModalOpen = true" class="preview-days">
        <span>{{selectedFilter}}</span>
        <img src="../../../../assets/icons/icon-arrow-dropdown.svg" alt="">
      </div>
    </div>
    <div class="wrapper-week-label">
      <span>{{selectedDate | dateRange: selectedFilter}}</span>
    </div>
  </div>
  <div class="line-gray"></div>
  <tl-insights-index
    *ngIf="!selectedDetailsType && !viewAllList && !selectedListId"
    [urlParams]="urlParams"
    (clickOnCard)="selectedDetailsType = $event; onChangePage.emit()"
    (clickOnList)="selectedListId = $event; onChangePage.emit()"
    (clickOnViewAllBtn)="viewAllList = true; onChangePage.emit()"
  ></tl-insights-index>

  <tl-insights-content-you-create
    *ngIf="viewAllList"
    [urlParams]="urlParams"
    (clickOnList)="selectedListId = $event; viewAllList = false;">
  </tl-insights-content-you-create>

  <tl-insights-details
    *ngIf="selectedDetailsType"
    [urlParams]="urlParams"
    [listId]="selectedListId"
    [detailsType]="selectedDetailsType">
  </tl-insights-details>

  <tl-insights-single-list
    *ngIf="!selectedDetailsType && selectedListId"
    [listId]="selectedListId"
    [urlParams]="urlParams"
    (clickOnCard)="selectedDetailsType = $event; onChangePage.emit()"
  ></tl-insights-single-list>
</div>

<tl-insights-date-picker
  *ngIf="isDatepickerModalOpen"
  [defaultSelectedFilter]="selectedFilter"
  [defaultSelectedDate]="selectedDate"
  (closeModal)="isDatepickerModalOpen = false"
  (confirmSelectedDate)="onChangeDateOrFilter($event)"
></tl-insights-date-picker>
